export default __webpack_public_path__ + "static/media/a011-fsi-04.4c1b5755.svg";